import { useState, useEffect } from 'react';
import InputFieldAddress from '../components/InputFieldAddress';
import { Box, Typography, TextField, Button, Stack } from '@mui/material'
import ClientAddressModal from './ClientAddressModal';
import { useWatch } from 'react-hook-form';

const OrderInfo = ({
    orderData,
    isEditMode = true,
    setOrderData,
    register,
    errors,
    setValue,
    control,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        if (orderData?.recipient_name) {
            setValue('recipient_name', orderData.recipient_name);
        }
    }, [orderData.recipient_name, setValue]);
    const clientId = useWatch({ control, name: 'client_id' });

    return (
        <>
            <Typography component='h2' variant="h4" mb={2}>お届け先および連絡事項</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', rowGap: 2, columnGap: 1, mb: 2, }}>
                {/* 配送希望日 */}
                <TextField
                    label="納品日"
                    type="date"
                    name="delivery_date"
                    disabled={!isEditMode}
                    error={!!errors.delivery_date}
                    helperText={errors.delivery_date?.message}
                    {...register('delivery_date',
                    )}
                />
                {/* 受取人氏名 */}
                <TextField
                    label="受取人氏名"
                    disabled={!isEditMode}
                    inputProps={{ maxLength: 100 }}
                    error={!!errors.recipient_name}
                    helperText={errors.recipient_name?.message}
                    {...register('recipient_name', {
                        required: '※受取人氏名は必須です',
                        maxLength: {
                            value: 100,
                            message: '※受取人氏名は100文字以内で入力してください'
                        }
                    })}
                />
            </Box>
            {/* 納品場所 */}
            <Stack direction="row" spacing={1} alignItems="start">
                <Box sx={{ flex: 1 }}>
                    <InputFieldAddress
                        register={register}
                        errors={errors}
                        isEditMode={isEditMode}
                        setValue={setValue}
                        control={control}
                        label='配送先住所'
                    />
                </Box>
                <Button
                    variant="outlined"
                    onClick={() => setIsModalOpen(true)}
                    disabled={!isEditMode || clientId == null}
                >
                    配送先住所を選択
                </Button>
            </Stack>
            {/* モーダル */}
            < ClientAddressModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                clientId={clientId}
                onSelectAddress={(address) => {
                    /*setOrderData({
                        ...orderData,
                        postal_code: address.postal_code,
                        state: address.state,
                        address_line: address.address_line,
                        shipping_address_id: address.address_id
                    });*/
                    setValue('shipping_address_id', address.address_id);
                    setValue('postal_code', address.postal_code);
                    setValue('state', address.state);
                    setValue('address_line', address.address_line);
                    setIsModalOpen(false);
                }}
            />

            {/* 連絡事項（注文メモ） */}
            <TextField
                label="連絡事項"
                multiline
                minRows={3}
                disabled={!isEditMode}
                error={!!errors.order_notes}
                helperText={errors.order_notes?.message}
                {...register('order_notes', {
                    maxLength: {
                        value: 2000,
                        message: '2000文字以内で入力してください',
                    },
                })}
                inputProps={{ maxLength: 2000 }}
                sx={{ mt: 2 }}
            />
        </>
    );
};

export default OrderInfo;
